import React, { useEffect, useState } from "react";
import {
  SurgicalGuideForm,
  SurgicalGuideProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";
import ToothSelector from "../formComp/ToothSelectorOld";

const SurgicalGuide: React.FC<SurgicalGuideProps> = ({ onChange }) => {
  const [form, setForm] = useState<SurgicalGuideForm>({
    dicomFile: "",
    stlFile: "",
    plannedImplantSites: [],
    plannedImplantManufacturer: "",
    teethExtractions: [],
    guideType: "",
    otherConsiderations: "",
    pilotDrillSize: "",
  });

  const handleToothClick = (
    type: "plannedImplantSites" | "teethExtractions",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof SurgicalGuideForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        SURGICAL GUIDE
      </h2>

      <div className="w-[100%] md:w-[90%]">
        <SelectInput
          label="DICOM file ready to upload"
          name="dicomFile"
          value={form.dicomFile}
          onChange={(e) => handleChange("dicomFile", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        <SelectInput
          label="STL file ready to upload"
          name="stlFile"
          value={form.stlFile}
          onChange={(e) => handleChange("stlFile", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Planned implant sited<span className="text-red-500">*</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.plannedImplantSites}
              onToothClick={(tooth) =>
                handleToothClick("plannedImplantSites", tooth)
              }
            />
          </div>
        </div>

        <TextInput
          label="Planned implant manufacturer"
          name="plannedImplantManufacturer"
          value={form.plannedImplantManufacturer}
          onChange={(e) =>
            handleChange("plannedImplantManufacturer", e.target.value)
          }
        />

        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Teeth to be extracted (if <br /> any)
            <span className="text-gray-400 text-sm"> Optional</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.teethExtractions}
              onToothClick={(tooth) =>
                handleToothClick("teethExtractions", tooth)
              }
            />
          </div>
        </div>

        <SelectInput
          label="Guide type"
          name="guideType"
          value={form.guideType}
          onChange={(e) => handleChange("guideType", e.target.value)}
          options={[
            { value: "Pilot-drill only", label: "Pilot-drill only" },
            { value: "Fully guided", label: "Fully guided" },
          ]}
        />

        {/* Conditionally render Size in mm */}
        {form.guideType === "Pilot-drill only" && (
          <TextInput
            label="Size in mm"
            name="pilotDrillSize"
            value={form.pilotDrillSize}
            onChange={(e) => handleChange("pilotDrillSize", e.target.value)}
          />
        )}
        <TextInput
          optional
          label="Other Considerations"
          name="otherConsiderations"
          value={form.otherConsiderations}
          onChange={(e) => handleChange("otherConsiderations", e.target.value)}
        />
      </div>
    </div>
  );
};

export default SurgicalGuide;
